export default __webpack_public_path__ + "static/media/4-2_image23@2x.af5a6faf.png";